
module.exports = {
  fitin: {
    pwa: {
      name: "FitIn",
      themeColor: "#FFB300"
    },
    app: {
      dark: true,
      themes: {
        light: {
          primary: '#2DA7B7', // '#3b5998', // colors.indigo.base,
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#e63d2c',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        },
        dark: {
          primary: '#2DA7B7',
          secondary: '#FFB944',
          accent: '#FFFFFF',
          error: '#E63D2C',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        }
      }
    }
  },
  hiveway: {
    pwa: {
      name: "Hiveway",
      themeColor: "#FFB300"
    },
    app: {
      dark: true,
      themes: {
        light: {
          primary: '#FEC526', // '#3b5998', // colors.indigo.base,
          secondary: '#5D606B',
          accent: '#82B1FF',
          error: '#e63d2c',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        },
        dark: {
          primary: '#FEC526', // '#3b5998', // colors.indigo.base,
          secondary: '#5D606B',
          accent: '#5D606B',
          error: '#e63d2c',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        }
      }
    }
  },
  uvalux: {
    pwa: {
      name: "Uvalux",
      themeColor: "#FCC462"
    },
    app: {
      dark: true,
      themes: {
        light: {
          primary: '#FCC462', // '#3b5998', // colors.indigo.base,
          secondary: '#5D606B',
          accent: '#82B1FF',
          error: '#e63d2c',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        },
        dark: {
          primary: '#FCC462', // '#3b5998', // colors.indigo.base,
          secondary: '#5D606B',
          accent: '#5D606B',
          error: '#e63d2c',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        }
      }
    }
  },
}

